import { useGT } from 'gt-react';
import type { FilterKey } from './demandFilters';

/**
 * Each shared procurement filter's name, as the filter bar shows it. One list
 * for the bar and for any summary that names an active filter (the buyer
 * board's collapsed filters line), so the two always agree.
 */
export function useDemandFilterLabels(): Record<FilterKey, string> {
  const gt = useGT();
  return {
    divisionIds: gt('Division', { context: 'demand filter' }),
    warehouseIds: gt('Warehouse', { context: 'demand filter' }),
    // `im_warehouses.type` — hub or branch.
    warehouseTypes: gt('Hub / branch', { context: 'demand filter' }),
    skuSearch: gt('SKU', { context: 'demand filter' }),
    textSearch: gt('Text', { context: 'demand filter' }),
    stockStatuses: gt('Stocked', { context: 'demand filter' }),
    popularityCodes: gt('Pop', { context: 'demand filter' }),
    demandClasses: gt('Demand class', { context: 'demand filter' }),
    methods: gt('Method', { context: 'demand filter' }),
    leadTimeSources: gt('Lead time', { context: 'demand filter' }),
    overrideOnly: gt('History override', { context: 'demand filter' }),
    monthRange: gt('Months', { context: 'demand filter' }),
  };
}

/**
 * A stock status as people read it under the "Stocked" filter: Yes / No for
 * the two `im_inventory_policies.stock_status` values, anything else as is.
 */
export function useStockStatusLabel(): (value: string) => string {
  const gt = useGT();
  return (value) =>
    value === 'stocked'
      ? gt('Yes', { context: 'demand filter stocked option: stocked' })
      : value === 'non_stock'
        ? gt('No', { context: 'demand filter stocked option: non-stock' })
        : value;
}
